import { IKnmBasicDictionary } from 'APIPackage/KnmModule/interfaces/IKnmDictionary';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';

export interface IViolationEventSelectOption extends ISelectOption {
  eventType?: IKnmBasicDictionary | null;
}

/**
 * Опции для поля «Осуществленное действие».
 * Нумерация «№ N» только если в паспорте несколько действий одного вида.
 */
export function createPassportEventSelectOptions(
  events: IKnmErknmFormEvent[] | undefined | null,
): IViolationEventSelectOption[] {
  if (!events?.length) {
    return [];
  }

  const typeCounts = new Map<string, number>();

  events.forEach(event => {
    if (!event.guid || !event.type) {
      return;
    }

    const typeTitle = event.type.title;

    typeCounts.set(typeTitle, (typeCounts.get(typeTitle) || 0) + 1);
  });

  const typeIndexes = new Map<string, number>();

  return events.reduce<IViolationEventSelectOption[]>((options, event) => {
    const eventGuid = event.guid;

    if (!eventGuid || !event.type) {
      return options;
    }

    const typeTitle = event.type.title;
    const currentIndex = (typeIndexes.get(typeTitle) || 0) + 1;

    typeIndexes.set(typeTitle, currentIndex);

    const label = (typeCounts.get(typeTitle) || 0) > 1 ? `${typeTitle} № ${currentIndex}` : typeTitle;

    options.push({
      id: eventGuid,
      label,
      value: eventGuid,
      eventType:
        event.type.value?.dictId && event.type.value?.dictVersionId
          ? {
              dictId: event.type.value.dictId,
              dictVersionId: event.type.value.dictVersionId,
            }
          : null,
    });

    return options;
  }, []);
}
